import { css } from 'emotion';
import theme from '@lyearn-team/theme-config';

export const contentRoot = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
`;

export const heading = css`
  font-family: PlayfairDisplay;
  font-size: 44px;
  line-height: 1.45;
  margin-bottom: 22px;
  text-align: center;
  max-width: 800px;
  color: ${theme.color.dark.silver};

  a {
    color: #437cff;
  }

  @media only screen and (max-width: 414px) {
    font-size: 24px;
  }
`;

export const text = css`
  font-size: 18px;
  line-height: 1.78;
  letter-spacing: 0.1px;
  color: ${theme.color.dark.silver};

  @media only screen and (max-width: 414px) {
    font-size: 16px;
  }
`;
